import { useQuery } from 'react-query'
import { getSaasUser } from '@lib/axios/user'
import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'
import qs from 'qs'

function useIndex() {
  const location = useLocation()
  const params = qs.parse(location.search, { ignoreQueryPrefix: true })
  const { status, data } = useQuery(
    ['saas-user', params],
    () => getSaasUser(params),
    {
      retry: false,
      staleTime: Infinity,
      keepPreviousData: true,
    }
  )
  const tableData = useMemo(
    // prettier-ignore
    () => (status === 'success' && Array.isArray(data?.data?.data)
      ? data?.data?.data
      : []),
    [status, data]
  )

  const emptyPagination = useMemo(
    () => ({
      current_page: 1,
      first_page: true,
      last_page: false,
      next_page: null,
      prev_page: null,
      total_pages: 1,
    }),
    []
  )

  const tablePagination = useMemo(
    // prettier-ignore
    () => (status === 'success' && data?.data?.pagination
      ? data?.data?.pagination
      : emptyPagination),
    [status, data, emptyPagination]
  )

  const columns = [
    ['id', 'ID', false],
    ['name', 'Nama Admin', false],
    ['email', 'Email', false],
    ['user_status', 'Status User', false],
    ['store_name', 'Nama Toko', false],
    ['total_amount', 'Total Dibayar', false],
    ['activation_status', 'Status', true],
    ['created_at', 'created_at ', true],
    ['updated_at', 'updated_at', true],
  ]

  const tableColumns = columns
    .map(([column, title]) => [column, title])
    .map(([accessor, Header]) => ({ accessor, Header }))

  const hiddenColumns = columns
    .filter(([, , hidden]) => hidden)
    .map(([column]) => column)

  return {
    tableData,
    tableColumns,
    hiddenColumns,
    tablePagination,
  }
}

export default useIndex
